exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".recipe-name[data-v-7a4baaae], .column-label[data-v-7a4baaae] {\n  font-size: 1.2rem;\n  font-weight: 500;\n  color: #3040C4;\n}\nselect.form-control[data-v-7a4baaae] {\n  border-color: #3040C4;\n  border-radius: 60px;\n  padding: 1.7rem 1rem;\n  font-size: 1rem;\n  height: auto;\n}\n.btn[data-v-7a4baaae] {\n  padding-top: 1.7rem;\n  padding-bottom: 1.7rem;\n  font-weight: 400;\n}", ""]);

// exports
